import React, { useRef, useEffect, useState, useContext } from 'react';
import { UserContext } from './UserContext';
import { getRequestNoParams, postRequest } from './Services/HttpClient';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import Certificate from './Certificate';

const Varnamalika = () => {
    const [randomVarna, setRandomVarna] = useState("");
    const [mappings, setMappings] = useState({});
    const [selectedValues, setSelectedValues] = useState({});
    const [typedRandomVarna, setTypedRandomVarna] = useState("");
    const [response, setResponse] = useState(null);
    const [score, setScore] = useState(0);
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [isGameActive, setIsGameActive] = useState(false);
    const [questionNumber, setQuestionNumber] = useState(1);
    const [displayQuestionNumber, setDisplayQuestionNumber] = useState(1);
    const [isSubmitDisabled, setIsSubmitDisabled] = useState(false);
    const [isRevealDisabled, setIsRevealDisabled] = useState(false);
    const {userDetails} = useContext(UserContext);
    const [showDownloadOptions, setShowDownloadOptions] = useState(false);
    const [showCertificate, setShowCertificate] = useState(false);
    const [usedVarnas, setUsedVarnas] = useState(new Set());
    const [responses, setResponses] = useState([]);
    const [displayResult, setDisplayResult] = useState(false);
    const certificateRef = useRef();
    const pointsForEachQuestion = 4;
    const totalQuestionsInAGame = 2;
    const numberOfUserSelection = 9;
    const bonusPoint = 1;
    const totalScore = 12;
    const revealScore = 1;

    const fetchRandomVarna = async () => {
        if (isGameActive) {
            let varna;
            do {
                varna = await getRequestNoParams('randomvarna');
                console.log('Fetched Random Varna:', varna.data);
            } while (usedVarnas.has(varna.data));
    
            setUsedVarnas(prevUsedVarnas => new Set(prevUsedVarnas).add(varna.data));
            setRandomVarna(varna.data);
        }
    };
    

    const fetchMappings = async () => {
        const mapping = await getRequestNoParams('mappinglist');
        console.log('Fetched Mappings:', mapping.data);
        setMappings(mapping.data);
    };

    const handleSelectChange = (key, values) => {
        console.log('Selected Key:', key);
        console.log('Selected Values:', values);

        setSelectedValues(prevValues => ({
            ...prevValues,
            [key]: values[0]
        }));
    };

    const handleRandomVarnaTypedChange = (value) => {
        setTypedRandomVarna(value);
    };

    const getResult = async (isReveal = false) => {
        try {
            const dataToSend = {
                randomVarna,
                typedRandomVarna,
                selectedValues
            };
            console.log('Random Varna:', randomVarna);
            console.log('Typed Random Varna:', typedRandomVarna);
            console.log('Payload being sent:', JSON.stringify(dataToSend));
            const response = await postRequest('validateVarnamaika', JSON.stringify(dataToSend), true);
            console.log('Backend Response Data:', response);
    
            if (response && response.data && response.data.details) {
                if (isReveal && response.data.details) {
                    const correctAnswers = {};
                    response.data.details.forEach(detail => {
                        Object.keys(detail).forEach(key => {
                            let expectedValue = detail[key]?.expectedValues;
                            if (expectedValue === null) {
                                expectedValue = 'None of these';
                            }
                            correctAnswers[key] = expectedValue;
                        });
                    });
                    if (correctAnswers[randomVarna]) {
                        console.log("Auto-populating with:", correctAnswers[randomVarna]);
                        setTypedRandomVarna(correctAnswers[randomVarna]);
                    }
                    setSelectedValues(correctAnswers);
                }

                if (typedRandomVarna === randomVarna) {
                    setScore(prevScore => prevScore + 1);
                }
                return response;
            }
        } catch (error) {
            console.error('Error submitting values:', error);
        }
    };    

    const handleSubmit = async () => {
        try {
            setIsSubmitDisabled(true);
            setIsRevealDisabled(true);
            console.log('Selected Values:', selectedValues);
            const response = await getResult();
            if (response && response.data) {
                setResponse(response.data);
                setScore(prevScore => prevScore + response.data.score);
                console.log('Response State Updated:', response.data);
                setResponses(prevResponses => [...prevResponses, {
                    question: displayQuestionNumber,
                    response: response.data,
                    typedVarna: typedRandomVarna,
                    correctRandomVarna: randomVarna
                }]);
            }
            setIsSubmitted(true);
            setQuestionNumber(prevNumber => prevNumber + 1);
        } catch (error) {
            console.error('Error submitting values:', error);
        }
    };

    const handleReveal = async () => {
        if (isGameActive) {
            setIsRevealDisabled(true);
            setIsSubmitDisabled(false);
            setScore(prevScore => prevScore - revealScore);
            await getResult(true);
        }
    };

    const handleDownloadPDF = () => {
        setTimeout(() => {
            html2canvas(certificateRef.current, { scale: 2 }).then(canvas => {
                const imgData = canvas.toDataURL('image/png');
                const pdf = new jsPDF('landscape', 'mm', 'a4');
                pdf.addImage(imgData, 'PNG', 0, 0, pdf.internal.pageSize.getWidth(), pdf.internal.pageSize.getHeight());
                pdf.save('certificate.pdf');
            }).catch(err => {
                console.error('Error capturing canvas:', err);
            });
        }, 500); 
    };
    
    const handleDownloadJPEG = () => {
        setTimeout(() => {
            html2canvas(certificateRef.current, { scale: 2 }).then(canvas => {
                const imgData = canvas.toDataURL('image/jpeg');
                const link = document.createElement('a');
                link.href = imgData;
                link.download = 'certificate.jpg';
                link.click();
            }).catch(err => {
                console.error('Error capturing canvas:', err);
            });
        }, 500);
    };    

    const handleDownload = () => {
        if ((score / totalScore) * 100 >= 40) {
            setShowDownloadOptions(true);
            setShowCertificate(true);
            setResponse(null);
        } else {
            setShowDownloadOptions(true); 
        }
    };

    const handleNextQuestion = () => {
        if (isGameActive) {
            setDisplayQuestionNumber(prevNumber => prevNumber + 1);
            fetchRandomVarna();
            fetchMappings();
            setSelectedValues({});
            setTypedRandomVarna("");
            setResponse(null);
            setIsSubmitted(false);
            setIsSubmitDisabled(false);
            setIsRevealDisabled(false);
        }
    };

    const handleViewResults = () => {
        setDisplayResult(true);
        setResponse(null);
    };

    const startGame = () => {
        setIsGameActive(true);
        setScore(0);
        setUsedVarnas(new Set());
        fetchRandomVarna();
        fetchMappings();
    };

    const endGame = () => {
        setIsGameActive(false);
        setScore(0);
        setRandomVarna("");
        setSelectedValues({});
        setTypedRandomVarna("");
        setResponse(null);
        setIsSubmitted(false);
        setMappings([]);
        setQuestionNumber(1);
        setDisplayQuestionNumber(1);
        setIsSubmitDisabled(false);
        setIsRevealDisabled(false);
        setResponses([]);
    };

    useEffect(() => {
        if (isGameActive) {
            fetchRandomVarna();
        }
        fetchMappings();
    }, [isGameActive]);

    useEffect(() => {
        console.log('Updated Score:', score);
    }, [score]);

    useEffect(() => {
        if (typedRandomVarna) {
            console.log('Typed Random Varna after update:', typedRandomVarna);
        }
    }, [typedRandomVarna]);

    return (
        <Container fluid="md">
            <div className='user-details'>
                {userDetails.photo && <img src={userDetails.photo} alt='Uploaded' className='uploaded-photo' />}
                {userDetails.name && <span className='user-name'>{userDetails.name}</span>}
            </div>
            <Row>
                <h2 className='varnamalika-text'><b>[M1.1] Varnamalika Test वर्णमालिका स्पर्धा</b></h2>
            </Row>
            <Row>
                {!isGameActive && (
                    <div className='varna-start-button'>
                        <b className="me-1">आरभस्व।</b>
                        <input
                            id="display-button"
                            type="submit"
                            value="Start"
                            onClick={startGame}
                            style={{ width: '150px', height: '50px', fontSize: '25px' }}
                        />
                    </div>
                )}
                {isGameActive && (
                    <div>
                        <b className='me-1'>समापय</b>
                        <input
                            id='display-button'
                            type='submit'
                            value='End'
                            onClick={endGame}
                            style={{ width: '100px', height: '30px' }}
                        />
                    </div>
                )}
            </Row>
            {isGameActive && (
                <>
                    <Row>
                        <h4 className='varnamalika-sub-heading'><b>Question: {displayQuestionNumber}</b></h4>
                    </Row>
                    <Row className="align-items-center mb-1 justify-content-start ms-5">
                        <Col md="auto">
                            <h3 className='ms-5'>वर्ण&nbsp;&nbsp;:</h3>
                        </Col>
                        <Col md="auto">
                            <div className="varna-box">
                                {randomVarna}
                            </div>
                        </Col>
                    </Row>
                    {Object.keys(mappings).map((key, index) => (                       
                        <Row key={key} className="mt-2">
                            <Col md="2" className="d-flex align-items-center dropdown-letters">
                                <label className={`mb-0 ${key === 'व्याकरण संज्ञा' || key === 'प्राचीन संज्ञा 3' ? 'underline' : ''}`}>
                                    <b>{index + 1} : {key}</b></label>
                            </Col>
                            <Col md="10">
                                <select
                                    onChange={(e) => handleSelectChange(key, [e.target.value])}
                                    className="dropdown"
                                    value={selectedValues[key] || ""}
                                >
                                    <option value="">Please Select</option>
                                    {mappings[key].map((item, idx) => (
                                        <option key={idx} value={item}>{item}</option>
                                    ))}
                                </select>
                            </Col>
                        </Row>
                    ))}
                    <Row>
                     <Col className='mt-3'>
                            <h5><strong>Type the Varna</strong></h5>
                        </Col>
                        <Col md="10" className='mt-3'>
                            <textarea
                                value={typedRandomVarna}
                                onChange={(e) => handleRandomVarnaTypedChange(e.target.value)}
                                onPaste={(e) => e.preventDefault()}
                                className="form-control no-resize"
                                rows="1"
                                style={{ width: '70px' }}
                            />
                        </Col>
                        </Row>
                    {isGameActive && (
                        <Row className="mt-4">
                            <Col md="10">
                                <input
                                    id='reveal-button'
                                    type='button'
                                    value='Reveal Answers'
                                    onClick={handleReveal}
                                    style={{ width: '170px', height: '30px' }}
                                    disabled={isRevealDisabled}
                                />
                            </Col>
                        </Row>
                    )}
                    {Object.keys(selectedValues).length >= numberOfUserSelection && (
                        <Row className="mt-4">
                            <Col md="12">
                                <input
                                    id='display-button'
                                    type='submit'
                                    value='Submit'
                                    onClick={handleSubmit}
                                    style={{ width: '170px', height: '30px' }}
                                    disabled={isSubmitDisabled}
                                />
                                {isSubmitted && displayQuestionNumber < totalQuestionsInAGame && (
                                    <input
                                        id='display-button'
                                        type='button'
                                        value='Next Question'
                                        onClick={handleNextQuestion}
                                        style={{ width: '170px', height: '30px', marginLeft: '5px' }} 
                                    />
                                )}
                                {isSubmitted && displayQuestionNumber === totalQuestionsInAGame && (
                                    <>
                                        {(score / totalScore) * 100 >= 40 ? (
                                            <>  
                                                <input
                                                    id='view-results-button'
                                                    type='button'
                                                    value='View Results'
                                                    onClick={handleViewResults}
                                                    style={{ width: '170px', height: '30px', marginLeft: '5px' }}
                                                />
                                                <input
                                                    id='download-button'
                                                    type='button'
                                                    value='Generate Certificate'
                                                    onClick={handleDownload}
                                                    style={{ width: '170px', height: '30px', marginLeft: '5px' }}
                                                />
                                                {showDownloadOptions && showCertificate && (
                                                    <>
                                                        <div className='certificate-display'> 
                                                            <Certificate ref={certificateRef} totalScore={totalScore} score={score}/>
                                                        </div>
                                                        <div className='md-10'>
                                                            <input
                                                                id='download-pdf-button'
                                                                type='button'
                                                                value='Save as PDF'
                                                                onClick={handleDownloadPDF}
                                                                style={{ width: '170px', height: '30px', marginTop: '0px',marginLeft: '5px' }}
                                                            />
                                                            <input
                                                                id='download-jpeg-button'
                                                                type='button'
                                                                value='Save as JPEG'
                                                                onClick={handleDownloadJPEG}
                                                                style={{ width: '170px', height: '30px', marginTop: '0px', marginLeft: '5px' }}
                                                            />
                                                            <input
                                                                    id="display-button"
                                                                    type="submit"
                                                                    value="Start Again"
                                                                    onClick={endGame}
                                                                    style={{ width: '170px', height: '30px', marginTop: '0px', marginLeft: '5px' }}
                                                            />
                                                        </div>
                                                    </>
                                                )}
                                            </>
                                        ) : (
                                            <>
                                                <input
                                                    id='view-results-button'
                                                    type='button'
                                                    value='View Results'
                                                    onClick={handleViewResults}
                                                    style={{ width: '170px', height: '30px', marginLeft: '5px' }}
                                                />
                                                <h5 className='mt-4 mb-4'>Better luck next time!</h5>
                                                <input
                                                    id="display-button"
                                                    type="submit"
                                                    value="Start Again"
                                                    onClick={endGame}
                                                    style={{ width: '170px', height: '30px', marginTop: '0px', marginLeft: '5px' }}
                                                />
                                            </> 
                                        )}
                                        {displayResult && (
                                        <Row className="mt-4">
                                            <Col>
                                                <h5>Score: {score}/{(totalQuestionsInAGame * pointsForEachQuestion) + displayQuestionNumber * bonusPoint}</h5>
                                                    {responses.map((item, index) => (
                                                        <div key={index}>
                                                            <h5>Question {item.question}</h5>
                                                            {item.response.details.map((detail, idx) => (
                                                                <div key={idx}>
                                                                    {Object.keys(detail).map((key) => {
                                                                        if (key === 'प्राचीन संज्ञा 3') {
                                                                            return (
                                                                                <div key={key}>
                                                                                    <p><strong>{key}:</strong> {detail[key].userSelectedValue !== null ? detail[key].userSelectedValue : 'None of these'} - 
                                                                                        {(detail[key].expectedValues === null && detail[key].userSelectedValue === 'None of these') ||
                                                                                        (Array.isArray(detail[key].expectedValues) && detail[key].expectedValues.includes(detail[key].userSelectedValue)) ||
                                                                                        (detail[key].userSelectedValue === detail[key].expectedValues)
                                                                                        ? 'Correct'
                                                                                        : `Incorrect (Correct Answer: ${detail[key].expectedValues})`}
                                                                                    </p>
                                                                                    <p><strong>Typed Varna:</strong> {item.typedVarna.trim() === item.correctRandomVarna.trim() 
                                                                                        ? `${item.typedVarna} - Correct`
                                                                                        : `${item.typedVarna} - Incorrect (Correct Answer: ${item.correctRandomVarna})`}
                                                                                    </p>
                                                                                </div>
                                                                            );
                                                                        }
                                                                        return (
                                                                            <p key={key}>
                                                                                <strong>{key}:</strong> {detail[key].userSelectedValue !== null ? detail[key].userSelectedValue : 'None of these'} - 
                                                                                {(detail[key].expectedValues === null && detail[key].userSelectedValue === 'None of these') ||
                                                                                (Array.isArray(detail[key].expectedValues) && detail[key].expectedValues.includes(detail[key].userSelectedValue)) ||
                                                                                (detail[key].userSelectedValue === detail[key].expectedValues)
                                                                                ? 'Correct'
                                                                                : `Incorrect (Correct Answer: ${detail[key].expectedValues})`}
                                                                            </p>
                                                                        );
                                                                    })}
                                                                </div>
                                                            ))}
                                                        </div>
                                                    ))}
                                                </Col>
                                            </Row>
                                        )}
                                        {!showDownloadOptions && !displayResult && (
                                            <Row>
                                                <Col>
                                                    <h5 className='mt-4'>Score: {score}/{(totalQuestionsInAGame * pointsForEachQuestion) + displayQuestionNumber * bonusPoint}</h5>
                                                </Col>
                                            </Row>
                                        )}
                                    </>
                                )}
                            </Col>
                        </Row>
                    )}
                    {response && response.details && (
                        <Row className="mt-4">
                            <Col>
                                <div>
                                    {response.details.map((detail, index) => (
                                        <div key={index}>
                                            {Object.keys(detail).map((key) => {
                                                const userSelectedValue = detail[key].userSelectedValue;
                                                const expectedValues = detail[key].expectedValues;

                                                let expectedValuesDisplay = expectedValues;
                                                if (expectedValues === null) {
                                                    expectedValuesDisplay = 'None of these';
                                                } else if (Array.isArray(expectedValues)) {
                                                    expectedValuesDisplay = expectedValues.join(', ');
                                                } else {
                                                    expectedValuesDisplay = expectedValues;
                                                }
                                                const isCorrect = (expectedValues === null && userSelectedValue === 'None of these') ||
                                                (Array.isArray(expectedValues) && expectedValues.includes(userSelectedValue)) ||
                                                (userSelectedValue === expectedValues);

                                                return (
                                                    <p key={key}>
                                                        <strong>{key}:</strong> {userSelectedValue !== null ? userSelectedValue : 'None of these'} - 
                                                        {isCorrect ? 'Correct' : `Incorrect (Correct Answer: ${expectedValuesDisplay})`}
                                                    </p>
                                                );
                                            })}
                                        </div>
                                    ))}
                                    <div>
                                        <p>
                                            <strong>Typed Varna:</strong> 
                                            {typedRandomVarna.trim() === randomVarna.trim() 
                                            ? `${typedRandomVarna} - Correct`
                                            : `${typedRandomVarna} - Incorrect (Correct Answer: ${randomVarna})`}
                                        </p>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    )}
                </>
            )}
        </Container>
    );
};

export default Varnamalika;
